import APITemplate from '@/api/APITemplate'

const url = '/api/supplier'

const template = APITemplate(url)
export default {
  ...template
}
